package com.essntl.features.profile.domain.repository

import com.essntl.features.profile.domain.model.ProfileModel

interface ProfileRepository {
    suspend fun getById(id: String): Result<ProfileModel>

    suspend fun getAll(): Result<List<ProfileModel>>

    suspend fun getAll(page: Long, limit: Int = 10): Result<List<ProfileModel>>

    suspend fun insert(profile: ProfileModel): Result<ProfileModel>

    suspend fun update(profile: ProfileModel): Result<ProfileModel>

    suspend fun delete(profile: ProfileModel): Result<Unit>
}
